export default class ElinorForward extends Phaser.Group {
  constructor(game) {
    super(game);

    this.char = this.game.make.spine(0, 0, 'elinor_talking_forward', true);
    this.char.anchor.set(0.5, 1);
    this.char.setAnimationByName(0, 'animation', true);
    this.addChild(this.char);

    this.rb = this.char.skeleton.getRootBone();
    this.scaleDefault = this.rb.scaleX;

    this.onClick = new Phaser.Signal();

    this.idle();
  }

  setScale(sc) {
    this.rb.scaleX = this.scaleDefault * sc;
    this.rb.scaleY = this.rb.scaleX;
  }

  idle() {
    this.char.setSkinByName('mouth/closed');

    this.updatePose();
  }

  talk() {
    this.char.setSkinByName('mouth/talking');
    this.updatePose();
  }

  updatePose() {
    const rb = this.rb;
    const x0 = rb.scaleX;
    const y0 = rb.scaleY;
    this.char.setToSetupPose();
    rb.scaleX = x0;
    rb.scaleY = y0;
  }

  getRootBone() {
    return this.rb;
  }

  enable() {
    this.char.inputEnabled = true;
    this.char.input.useHandCursor = true;
    this.char.events.onInputDown.add(this.handleInputDown, this);
  }

  disable() {
    this.char.inputEnabled = false;
    this.char.input.useHandCursor = false;
    this.char.events.onInputDown.remove(this.handleInputDown, this);
  }

  handleInputDown() {
    this.onClick.dispatch();
  }
}
